/**
 * @description Serves as the base class for application-defined exceptions.
 *
 * @class ApplicationException
 *
 * @extends {Error}
 */
class ApplicationException extends Error {
    constructor(message) {
        super(message);

        this.name = 'ApplicationException';
    }
}

module.exports = ApplicationException;
